import Vue from 'vue'
import Vuex from 'vuex'
// 引入模块
import user from './modules/user'
import permission from './modules/permission'
import website from './modules/website'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // editorSearchValue:'',
    // editorSearchUserList:[]
  },
  mutations: {
    // changeEditorSearchValue(state,payloadStr){
    //   state.editorSearchValue = payloadStr
    // },
    // changeEditorSearchUserList(state,payload){
    //   state.editorSearchUserList = payload
    // }
  },
  actions: {
    // searchEditorUserList(context,payload){
    //   console.log(this);
    // }
  },
  modules: {
    user,
    permission,
    website
  }
})
